var _path, _path2, _path3, _g, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 94,
    viewBox: "0 0 269 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.791 32.6421C107.791 19.5059 118.506 8.79086 131.642 8.79086C134.166 8.79086 136.588 9.20298 138.854 9.92418L142.718 6.26664C139.318 4.82423 135.557 4 131.642 4C115.879 4 103 16.8787 103 32.6421C103 35.9906 103.567 39.1845 104.648 42.1723L108.512 38.5148C108.048 36.6603 107.791 34.7027 107.791 32.6421Z",
    fill: "#4D8FF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.642 56.545C120.566 56.545 111.139 48.8693 108.512 38.5664L104.648 42.2239C108.615 53.3511 119.227 61.3359 131.642 61.3359C134.527 61.3359 137.36 60.8722 140.039 60.0995L134.372 56.442C133.497 56.442 132.569 56.545 131.642 56.545Z",
    fill: "#FF542E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.284 32.6421C160.284 20.7937 153.02 10.5938 142.717 6.2666L138.854 9.92414C148.487 13.015 155.493 22.0301 155.493 32.6421C155.493 44.8511 146.22 54.9995 134.372 56.3388L140.039 59.9964C151.733 56.4419 160.284 45.5208 160.284 32.6421Z",
    fill: "#4E55A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.091 67.6835L149.255 49.5575C153.502 45.2418 156.05 39.1998 156.05 32.5824C156.05 19.0598 145.291 8.12665 131.985 8.12665C118.395 7.83893 107.636 18.7721 107.636 32.2947C107.636 45.8172 118.395 56.7504 131.701 56.7504C136.514 56.7504 141.044 55.3118 144.725 52.7224L162.845 71.1361C163.411 71.7115 164.26 71.9992 164.826 71.9992C165.393 71.9992 166.242 71.7115 166.808 71.1361C168.224 70.5607 168.224 68.8344 167.091 67.6835ZM113.299 32.2947C113.299 21.9369 121.509 13.5932 131.701 13.5932C141.894 13.5932 150.104 21.9369 150.104 32.2947C150.104 42.6524 141.894 50.9961 131.701 50.9961C121.509 51.2838 113.299 42.9401 113.299 32.2947Z",
    fill: "#787878"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2252 47.2851L23.2576 37.1558C25.6308 34.744 27.0548 31.3676 27.0548 27.6696C27.0548 20.1128 21.0426 14.0031 13.6065 14.0031C6.01217 13.8423 0 19.9521 0 27.5088C0 35.0656 6.01217 41.1753 13.4483 41.1753C16.1379 41.1753 18.6694 40.3714 20.7262 38.9244L30.8519 49.2145C31.1684 49.536 31.643 49.6968 31.9594 49.6968C32.2759 49.6968 32.7505 49.536 33.0669 49.2145C33.858 48.8929 33.858 47.9282 33.2252 47.2851ZM3.1643 27.5088C3.1643 21.7207 7.75254 17.058 13.4483 17.058C19.144 17.058 23.7323 21.7207 23.7323 27.5088C23.7323 33.297 19.144 37.9597 13.4483 37.9597C7.75254 38.1205 3.1643 33.4578 3.1643 27.5088Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.648 25.6939L260.953 17.8747C262.785 16.013 263.884 13.4066 263.884 10.552C263.884 4.7187 259.243 0.0023947 253.503 0.0023947C247.641 -0.121719 243 4.59459 243 10.4279C243 16.2612 247.641 20.9775 253.381 20.9775C255.457 20.9775 257.412 20.357 258.999 19.24L266.816 27.1832C267.06 27.4314 267.426 27.5556 267.671 27.5556C267.915 27.5556 268.281 27.4314 268.525 27.1832C269.136 26.935 269.136 26.1903 268.648 25.6939ZM245.443 10.4279C245.443 5.95984 248.984 2.36055 253.381 2.36055C257.778 2.36055 261.32 5.95984 261.32 10.4279C261.32 14.896 257.778 18.4953 253.381 18.4953C248.984 18.6194 245.443 15.0201 245.443 10.4279Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.715 59.7527L231.501 53.4373C232.98 51.9336 233.868 49.8284 233.868 47.5228C233.868 42.8113 230.12 39.0019 225.483 39.0019C220.748 38.9017 217 42.711 217 47.4225C217 52.1341 220.748 55.9434 225.385 55.9434C227.062 55.9434 228.64 55.4422 229.922 54.54L236.236 60.9557C236.433 61.1562 236.729 61.2564 236.926 61.2564C237.123 61.2564 237.419 61.1562 237.617 60.9557C238.11 60.7552 238.11 60.1537 237.715 59.7527ZM218.973 47.4225C218.973 43.8137 221.834 40.9066 225.385 40.9066C228.936 40.9066 231.797 43.8137 231.797 47.4225C231.797 51.0314 228.936 53.9385 225.385 53.9385C221.834 54.0387 218.973 51.1316 218.973 47.4225Z",
    fill: "#4A4A4A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 93.6362,
    y: 2.12109,
    width: 88.2721,
    height: 91.8782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/Search_Dark.5f5aaa4bd8736fe758e3cf197a4841ef.svg";
export { ForwardRef as ReactComponent };